<template>
  <div>
    <b-nav-item-dropdown right v-if="nav">
      <template #button-content>
        <b-img
          :src="require('../assets/' + selectedLanguage + '.svg')"
          class="mr-2"
        />
      </template>
      <b-dropdown-item
        v-for="language in languageOptions"
        :key="language.value"
        @click="clickHandler(language.value)"
      >
        <b-img
          :src="require('../assets/' + language.value + '.svg')"
          class="mr-2"
        />
        {{ language.text }}
      </b-dropdown-item>
    </b-nav-item-dropdown>
    <b-form-select
      v-else
      v-model="selectedLanguage"
      :options="languageOptions"
      @input="inputHandler"
    />
  </div>
</template>

<script>
import { Language } from "psy-sdk";

export default {
  name: "CompLanguageSelector",
  props: {
    nav: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedLanguage: this.$i18n.locale,
      languageOptions: [],
    };
  },
  methods: {
    inputHandler() {
      this.$i18n.locale = this.selectedLanguage;
      this.$cookie.set("lang", this.$i18n.locale, { expires: "1Y" });
      this.$eventBus.$emit("user-language-changed");
      this.loadLanguages();
      this.$forceUpdate();
    },
    clickHandler(lang) {
      this.selectedLanguage = lang;
      this.inputHandler();
    },
    loadLanguages() {
      Language.readAll(this.$i18n.locale).then((languages) => {
        this.languageOptions = Language.toSelectOptions(
          languages,
          Language.SUPPORTED_ONLY
        );
      });
    },
  },
  created() {
    this.loadLanguages();
    this.$eventBus.$on("language-changed", () => {
      this.selectedLanguage = this.$i18n.locale;
      this.$cookie.set("lang", this.$i18n.locale, { expires: "1Y" });
      this.$forceUpdate();
    });
  },
};
</script>